import type React from 'react';

import type { TranscriptCue } from '../player/player.interface';

import { useTranslation } from 'react-i18next';

import { useSyncWithVideo } from './use-sync-with-video';
import { SyncWithVideoIcon } from '../../icons/sync-with-video';

import styles from './transcript.module.css';

type SyncWithVideoProps = {
  itemIdPrefix: string;
  currentActiveCue: TranscriptCue | undefined;
  cues: TranscriptCue[] | undefined;
  scrollToTranscriptItem: (index: number) => void;
  scrollRef: React.RefObject<HTMLDivElement>;
  shown?: boolean;
  autoScrollEnabled: boolean;
  setAutoScrollEnabled: React.Dispatch<React.SetStateAction<boolean>>;
};

export function SyncWithVideoButton({
  currentActiveCue,
  cues,
  scrollToTranscriptItem,
  scrollRef,
  shown,
  autoScrollEnabled,
  setAutoScrollEnabled,
}: SyncWithVideoProps) {
  const { t } = useTranslation();

  const { syncWithVideoEnabled, syncWithVideo } = useSyncWithVideo({
    currentActiveCue,
    cues,
    scrollToTranscriptItem,
    scrollRef,
    shown,
    autoScrollEnabled,
    setAutoScrollEnabled,
  });

  return syncWithVideoEnabled ? (
    <button role="menuitem" onClick={syncWithVideo} className={styles.syncWithVideoButton}>
      {t('ui.transcript.menu.sync-with-video.button.label')}
      <SyncWithVideoIcon />
    </button>
  ) : undefined;
}
